import React from 'react';
import { withRouter } from 'react-router-dom';

import './CustomButton.css';

class CustomButton extends React.Component {
    onClick = () => {
        if (!this.props.loading) {
            if (typeof this.props.action === 'function') {
                this.props.action();
            } else {
                this.props.history.push(this.props.action);
            }
        }
    };
    render() {
        const buttonClass =
            'custom-button ' +
            this.props.type +
            ' ' +
            (this.props.align || 'center');

        return (
            <div className={buttonClass}>
                <a onClick={this.onClick}>
                    {this.props.label}
                    {this.props.loading && (
                        <div className="loading-wheel-container">
                            <div className="loading-wheel" />
                        </div>
                    )}
                </a>
            </div>
        );
    }
}

export default withRouter(CustomButton);



// WEBPACK FOOTER //
// ./src/modules/form/components/custom-button/CustomButton.jsx